module.exports.troublemaker = {
  vi: {
    title: 'Kẻ gây rối (Troublemaker) trong Avalon: vai Thiện, kiểm tra ra Ác',
    description:
      'Vì sao Kẻ gây rối trông như thuộc phe Ác trong Avalon? Tìm hiểu những kiểm tra phe gây hiểu lầm, có bắt buộc nói dối không và được dùng thẻ Nhiệm vụ nào.',
    keywords: ['Kẻ gây rối', 'Vai trò', 'Luật chơi', 'Mẹo chơi'],
  },
  pt: {
    title: 'Encrenqueiro em Avalon: bom com verificação de mal',
    description:
      'Por que o Encrenqueiro parece mau em Avalon? Verificações enganosas, direito de falar a verdade, Sucesso obrigatório e diferença para o Trapaceiro.',
    keywords: ['Encrenqueiro', 'Papel', 'Regras', 'Dicas'],
  },
  en: {
    title: 'Troublemaker in Avalon: Good Role, Evil Check',
    description:
      'Why does the Troublemaker look evil in Avalon? Learn which loyalty checks are misleading, whether lying is compulsory and which mission card is allowed.',
    keywords: ['Troublemaker', 'Role', 'Rules', 'Tips'],
  },
  ru: {
    title: 'Траблмейкер в Авалоне: добро с проверкой «зло»',
    description:
      'Почему Траблмейкер выглядит злым в Авалоне? Ложные проверки, право говорить правду, обязательный успех и отличие от Трикстера.',
    keywords: ['Траблмейкер', 'Роль', 'Правила', 'Советы'],
  },
  'zh-TW': {
    title: '阿瓦隆麻煩友：好人為何被查成壞人',
    description: '阿瓦隆麻煩友為什麼顯示邪惡？了解誤導陣營查驗、是否必須說謊、任務只能成功的規則，以及與騙子的區別。',
    keywords: ['麻煩友', '角色', '規則', '建議'],
  },
  'zh-CN': {
    title: '阿瓦隆麻烦友：好人为何被查成坏人',
    description: '阿瓦隆麻烦友为什么显示邪恶？了解误导阵营查验、是否必须说谎、任务只能成功的规则，以及与骗子的区别。',
    keywords: ['麻烦友', '角色', '规则', '建议'],
  },
  es: {
    title: 'Problematizador en Avalon: rol bueno, comprobación mala',
    description:
      '¿Por qué el Problematizador parece malo en Avalon? Comprobaciones engañosas, derecho a decir la verdad, Éxito obligatorio y diferencia con el Tramposo.',
    keywords: ['Problematizador', 'Rol', 'Reglas', 'Consejos'],
  },
};
